// extracted by mini-css-extract-plugin
export default {"input":"DayQuantityCell_input__X-QQc","cell":"DayQuantityCell_cell__O0OQH"};